import { gql } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';

export const CUSTOM_LINE_FRAGMENT = gql`
  fragment CustomLineFragment on CustomLine {
    id
    number
    description
    quantity {
      unit
      value
    }
    customProperties {
      stringValue
      key
    }
    customProductName
    customProductText
    article {
      id
      name
      description
      mnr
      ean
      width
      height
      depth
      direction
      category {
        displayName
      }
    }
    articleCustom {
      id
      name
      description
      mnr
      ean
      width
      height
      depth
      direction
      category {
        displayName
      }
    }
    ...CustomLinePricingFragment
  }
  ${CUSTOM_LINE_PRICING_FRAGMENT}
`;
